import React from 'react';
import PropTypes from 'prop-types';

const BooleanRow = ({ data, groupKey, cellKey, color, length }) => (
  <div className="time-line-view-body-row-content-row">
    {data.map((item) => (
      <div
        className={item.filled ? 'filled' : ''}
        style={{
          width: `${(((item.end - item.start + 1) / length) * 100).toFixed(2)}%`,
          backgroundColor: color,
        }}
        key={`time-line-view-body-row-content-number-${groupKey}-${cellKey}-${item.start}-${item.end}`}
      />
    ))}
  </div>
);

BooleanRow.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cellKey: PropTypes.string.isRequired,
  groupKey: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  length: PropTypes.number.isRequired,
};
export default BooleanRow;
